module.exports = __webpack_public_path__ + "img/1.2e4b1e2b.jpg";